import { render } from "./CustomCursor.vue?vue&type=template&id=12e7ea40&scoped=true"
import script from "./CustomCursor.vue?vue&type=script&lang=js"
export * from "./CustomCursor.vue?vue&type=script&lang=js"

import "./CustomCursor.vue?vue&type=style&index=0&id=12e7ea40&scoped=true&lang=css"

import exportComponent from "/home/runner/work/abdc-frontend/abdc-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e7ea40"]])

export default __exports__